// Angular
import { Component, Input, OnInit, ViewChild, ChangeDetectorRef,ViewRef } from '@angular/core';

import { finalize } from 'rxjs/operators';


import { MatDialog} from '@angular/material/dialog';

import { NotificationService } from 'app/core/topbar/_services/notification.service';
import { Notification } from 'app/core/topbar/models/notification.model';
import { NotificationDetailComponent } from '../notification-detail/notification-detail.component';
import { EntityType } from 'app/core/ana/entities/models/entityType-model';
import { EntitiesService, EntityTypesService } from 'app/core/ana/entities';
import { EntitiesAccessService } from 'app/core/common/_services/entities-access.service';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
    selector: 'kt-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['notification.component.scss']
})
export class NotificationComponent implements OnInit {


	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';

	public notificationList: Array<Notification>;
	public notificationQtys: number;

	/** Shows the topbar bell / icon wrapper when there are notifications (do not reuse @Input useSVG for this). */
	public showTopbarTrigger = false;

	public entitiesTypesList: Array<EntityType> = [];

	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	 active = 1;
	constructor(
		private dialog: MatDialog,
		private notificationService: NotificationService,
		private chRef: ChangeDetectorRef,
		private entitiesService: EntitiesService,
		private entitiesAccessService: EntitiesAccessService)
	{
		this.notificationService.processAnnounced$.subscribe(
			data => {
				if(data) {
					this.getNotificationList();
				}
			}
		)
	}


	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}

	ngOnInit() {
		this.notificationQtys = 0;
		this.showTopbarTrigger = false;
		this.loadEntitiesContrains();
	}

	/** True when icon @Input is an image path (SVG/PNG) rather than a CSS icon class. */
	isIconAssetUrl(icon: string): boolean {
		if (!icon || typeof icon !== 'string') {
			return false;
		}
		const t = icon.trim().toLowerCase();
		return (
			t.endsWith('.svg') ||
			t.endsWith('.png') ||
			t.endsWith('.jpg') ||
			t.endsWith('.jpeg') ||
			t.endsWith('.webp') ||
			t.includes('/media/icons/')
		);
	}

	/**
	 * Method that loads a list of Notifications to display on the datatable
	 * @author Rosa Korse
	 * @since 2020-03-24
	 */
	private getNotificationList() {

		this.notificationService.list()
			.pipe(
				finalize(() => {

					if (this.chRef && !(this.chRef as ViewRef).destroyed) {
						this.chRef.detectChanges();
					}
				})
			)
			.subscribe(
				list => {
					this.notificationList = list;
					this.notificationQtys = list.length;
					this.showTopbarTrigger = this.notificationQtys > 0;
				},
			);
	}

	/**
	 * Check for user entity access
	 * @author Rosa Korse
	 * @since 2020-04-21
	 */
	private loadEntitiesContrains() {

		this.entitiesAccessService.getAllEntitiesByUser(environment.notificationEntityKey).subscribe(
			data => {

					let entityList: string[] = data;

					if (entityList.includes("ALL") || entityList.includes("EDIMessages") ) {

						this.getNotificationList();
				    }

			});

	}

	/**
	 * Checks if theres a new change in the dom to be forced
	 * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
	 * @since 2020-03-20
	 */
	public updateDOM() {
		if (this.chRef && !(this.chRef as ViewRef).destroyed) {
			this.chRef.detectChanges();
		}
	}


	/**
   * Show Notification Details
   * @author Rosa Korse
   * @since 2020-03-24
   */
	openNotificationDetails(element) {

		let notificationModal =
			this.dialog.open(NotificationDetailComponent, {
				width: '760px',
				maxWidth: '95vw',
				maxHeight: '90vh',
				panelClass: 'notification-detail-dialog'
			});
		notificationModal.componentInstance.notification = element;
		notificationModal.componentInstance.notificationProcessed.subscribe(
			($data) => {
				if ($data) {
					this.getNotificationList();
				}
			}

		);
	}


}
